<script>
    import "../modals/modal.css"
    let crossModal = "./images/cross.svg"
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    const modalAction = () => {
        dispatch("modalAction")
    }
    export let modalStatus;
</script>
{#if modalStatus}
<div class="unix-modal">
    <div class="unix-modal-dialog flex items-center">
        <div class="unix-modal-content flex column-direction">
            <img src={crossModal} id="cross-modal" on:click={modalAction} alt="Cross Button">
            <h2 class="modal-title">Buy rTKN</h2>
            <slot></slot>
        </div>
    </div>
</div>
    {/if}